import React, { Component } from "react";
import { connect } from "react-redux";

import $ from "jquery";
// import axios from "axios";

import * as sisMapActions from "store/modules/rds_sisMap";

// import { Button, TextArea, Form } from "semantic-ui-react";
// import { GiPositionMarker } from "react-icons/gi";
// import { MdDeleteForever } from "react-icons/md";

import SisModal from "store/sis/sisModal";

import css from "./mapInformation.module.scss";
import { bindActionCreators } from "redux";

import lodash from "lodash";
import { none } from "ol/centerconstraint";

class Memo extends Component {
	state = {
		lstLayerInfo: "",
	};

	componentDidMount() {
		$.ajax({
			url: "/map/selectLayerInfo",
			type: "post",
			data: {
				role: "PUB",
			},
			success: (res) => {
				let items = lodash
					.chain(res)
					.groupBy("LMenu")
					.map((data, key) => {
						return { key, value: data };
					})
					.value();

				const lstLayerInfo = items.map((item, i) => {
					return item.value.map((v, idx) => {
						const mMenu = v.MMenu.split("\\n");
						const sMenu = v.SMenu.split("\\n");
						const source = v.source.split("\\n");
						const updateDate = v.updateDate.split("\\n");
						const updateCycle = v.updateCycle.split("\\n");

						if (idx === 0) {
							return (
								<tr key={idx}>
									<td rowSpan={item.value.length} style={{ background: "#fff" }}>
										{item.key}
									</td>
									<td>
										{mMenu.map((item, idx) => {
											if (idx !== mMenu.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
									<td>
										{source.map((item, idx) => {
											if (idx !== source.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
									<td>
										{updateDate.map((item, idx) => {
											if (idx !== updateDate.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
									<td>
										{updateCycle.map((item, idx) => {
											if (idx !== updateCycle.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
								</tr>
							);
						} else {
							return (
								<tr key={idx}>
									<td>
										{mMenu.map((item, idx) => {
											if (idx !== mMenu.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
									<td>
										{source.map((item, idx) => {
											if (idx !== source.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
									<td>
										{updateDate.map((item, idx) => {
											if (idx !== updateDate.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
									<td>
										{updateCycle.map((item, idx) => {
											if (idx !== updateCycle.length - 1)
												return (
													<span key={idx}>
														{item}
														<br />
													</span>
												);
											else return <span key={idx}>{item}</span>;
										})}
									</td>
								</tr>
							);
						}
					});
				});

				this.setState({
					lstLayerInfo,
				});
			},
		});
	}

	render() {
		const contents = (
			<div className={css.tableWrap}>
				<table>
					<caption>주제도</caption>
					<thead>
						<tr>
							<th colSpan="2">구분</th>
							<th>출저</th>
							<th>최종갱신일</th>
							<th>갱신주기</th>
						</tr>
					</thead>
					{/*<tbody>{this.state.lstLayerInfo}</tbody>*/}
				</table>
			</div>
		);

		return (
			<div>
				<SisModal id={this.props.id} className={css.mapInformation} background title="주제도 정보" contents={contents} />
			</div>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
	})
)(Memo);
